// extracted by mini-css-extract-plugin
export var button = "_lx-2";
export var card = "_lx-0";
export var closeButtonContainer = "_lx-3";
export var iconContainer = "_lx-1";